// removed by extract-text-webpack-plugin
module.exports = {"login-form":"app-pages-Login-__style-form___3HYVv","field-wrapper":"app-pages-Login-__style-form___2Ojtx","field-input":"app-pages-Login-__style-form___3WVD8","submit-btn":"app-pages-Login-__style-form___2LTAX"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Login/style.form.css
// module id = 2464
// module chunks = 0